<div class="intro">
  <div class="row">
    <section #content class="col content">
      <h2 [innerHtml]="'research.portal.title' | translate"></h2>
      <p [innerHtml]="'research.portal.subtitle' | translate" class="main-desc"></p>
      @if (homepageScopes?.length > 0) {
        <ul class="links primary-links">
          @for (scope of homepageScopes; track scope.code) {
            <li>
              @if (scope.isOTB) {
                <a [queryParams]="getQueryParams(scope)" [routerLink]="getRouterLink()">
                  {{ scope.code | translate }}
                </a>
              } @else {
                <a [href]="scope.url" [target]="getHrefTarget(scope.open)">
                  {{ scope.code | translate }}
                </a>
              }
            </li>
          }
        </ul>
      }
      <hr />
      @if (entities?.length > 0) {
        <ul class="links">
          @for (entity of entities; track entity.code) {
            @if (entity.active) {
              <li>
                <a [queryParams]="getEntityParams(entity)" [routerLink]="entity.path">
                  {{
                  'esploro.research.conf.research.portal.label.prefix.' + entity.code | translate
                  }}
                </a>
              </li>
            }
          }
        </ul>
      }
    </section>
    @if (homepageImages?.length > 0) {
      <div class="col slider">
        <swiper
          #swiperElem
          [autoplay]="true"
          [pagination]="homepageImages.length > 1 ? { clickable: false } : false"
          [slidesPerView]="1"
          [spaceBetween]="50"
          effect="fade"
          >
          @for (image of homepageImages; track image; let i = $index) {
            <ng-template swiperSlide>
              <img [src]="image" alt="" />
            </ng-template>
          }
        </swiper>
        @if (homepageImages?.length > 1) {
          <button
            [attr.aria-label]="swiperRunning ? 'pause' : 'play'"
            mat-mini-fab
            color="primary"
            (click)="swiperRunning ? swiperStop() : swiperStart()"
            >
            <mat-icon [svgIcon]="swiperRunning ? 'pause' : 'play'"></mat-icon>
          </button>
        }
      </div>
    }
  </div>
</div>
